// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";       // <-- Add this for Firebase Authentication
import { getFirestore } from "firebase/firestore"; // <-- Add this for Cloud Firestore
import { getStorage } from "firebase/storage";   // <-- Add this for Firebase Storage
import { getAnalytics } from "firebase/analytics"; // Keep this if you want analytics

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBI3h1iWxlTwTIRguESXlwabXPwfSBne1I",
  authDomain: "kay-penang-property-listing.firebaseapp.com",
  projectId: "kay-penang-property-listing",
  storageBucket: "kay-penang-property-listing.firebasestorage.app",
  messagingSenderId: "769697776892",
  appId: "1:769697776892:web:e5687ee2d51edf91244379",
  measurementId: "G-7BCGFPCE9C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services and export them
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app); // Export analytics too if you plan to use it

export default app; // Export the app instance itself if needed